import { Button } from '@fsd/ui';
import { Moon, Sun } from '@solar-icons/react';
import { useTheme } from '../themeProvider';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      aria-label="Alternar tema"
      title={isDark ? 'Modo claro' : 'Modo escuro'}
      className="relative h-9 w-9 p-0"
    >
      <Sun
        size={20}
        className={`absolute inset-0 m-auto transition-all duration-500 ${
          isDark ? 'scale-0 rotate-90 opacity-0' : 'scale-100 rotate-0 opacity-100'
        }`}
      />
      <Moon
        size={20}
        className={`absolute inset-0 m-auto transition-all duration-500 ${
          isDark ? 'scale-100 rotate-0 opacity-100' : 'scale-0 -rotate-90 opacity-0'
        }`}
      />
      <span className="sr-only">{isDark ? 'Modo claro' : 'Modo escuro'}</span>
    </Button>
  );
}
